import { SocketEvent, SocketNamespace } from './constant'

import type { EmitParameter, SocketData } from './types'

import { getEnvConfig } from '@/utils/env-variables'
import { emit } from '@/utils/event-bus'
import { getContextData, ContextDataKey } from '@/utils/context-data'

class WebSocket {
  static socketInstances: Map<string, any> = new Map<string, any>()

  /**
   * @description Lấy ra instance theo namespace. Nếu chưa connect vào namespace đó sẽ connect luôn
   * @param namespace
   * @author PVThang
   */
  getSocketInstance (namespace: string) : any {
    const me = this

    if (!(WebSocket.socketInstances.get(namespace))) {
      me.connect(namespace)
    }

    return WebSocket.socketInstances.get(namespace)
  }

  /**
   * @description merge payload với một số dữ liệu mặc định
   * @param payload
   * @author PVThang
   */
  mergePayload (payload: EmitParameter) {
    payload ??= {} as EmitParameter
    if (!payload.UserID) {
      payload.UserID = getContextData(ContextDataKey.UserID)
    }
    return payload
  }

  /**
   * @description Kết nối vào 1 namespace, kết nối xong sẽ lắng nghe sự kiện SocketEvent.NewNotify luôn
   * @param namespace
   * @author PVThang
   */
  connect (namespace: string = SocketNamespace.Default) {
    const userID = getContextData(ContextDataKey.UserID)
    /**
     * Chưa kết nối theo namespace vì chưa cần dùng đến
     */
    const socket = window.io(getEnvConfig('socketIOPath'), {
      transports: ['websocket']
    }).connect()

    socket.emit(SocketEvent.JoinRoomV2, {
      RoomID: userID,
      UserID: userID
    } as EmitParameter)
    socket.on(SocketEvent.NewNotify, function (socketData: SocketData) {
      emit(socketData.EventName, socketData.Data)
    })
    WebSocket.socketInstances.set(namespace, socket)
  }

  /**
   * @description join vào 1 room
   * @param payload data gửi đi
   * @author PVThang
   */
  joinRoom (payload: EmitParameter, namespace: string = SocketNamespace.Default) {
    const me = this
    const socketInstance = me.getSocketInstance(namespace)

    socketInstance.emit(SocketEvent.JoinRoomV2, me.mergePayload(payload))
  }

  /**
   * @description rời khỏi room
   * @param payload data gửi đi
   * @author PVThang
   */
  leaveRoom (payload: EmitParameter, namespace: string = SocketNamespace.Default) {
    const me = this
    const socketInstance = me.getSocketInstance(namespace)

    socketInstance.emit(SocketEvent.LeaveRoomV2, me.mergePayload(payload))
  }
}

export default WebSocket
